import * as React from "react"
import { StoreProvider } from "./src/context/store-context"
import 'assets/stylesheets/application.scss';

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
)